import { minByOrThrow } from "@dhau/lang-extras";
import type { PictureConfiguration } from "@brickme/project-core/src/model/picture.ts";
import { availableDetailValues } from "@brickme/project-core/src/model/detail-filter.ts";
import type {
	BaseplateSize,
	NumberOfBaseplates,
} from "@brickme/project-core/src/model/project-primitives.ts";
import {
	originPosition,
	multiplySize,
} from "@brickme/project-core/src/model/geom.ts";
import getDefaultNumberOfBasePlates from "./get-default-number-of-base-plates.ts";

const defaultAutoPaletteModeNumberOfColours = 20;
const defaultContrast = 0.15;
const defaultSaturation = 0.05;
const defaultBrightness = 0;

function createDefaultPictureConfiguration(
	basePlateSizes: readonly BaseplateSize[],
	imageWidth: number,
	imageHeight: number,
	explicitNumberOfBasePlates: NumberOfBaseplates | undefined,
): PictureConfiguration {
	const numberOfBasePlates =
		explicitNumberOfBasePlates ??
		getDefaultNumberOfBasePlates(imageWidth, imageHeight);
	const defaultDetailFilter =
		availableDetailValues[(Math.min(availableDetailValues.length - 1), 1)];
	// Want the closest base plate to 24
	const basePlateSize = minByOrThrow(basePlateSizes, (s) => Math.abs(s - 24));
	return {
		imageZoom: 1,
		imageZoomOffset: originPosition,
		basePlateSize,
		numberOfBasePlates,
		numberOfBricks: multiplySize(numberOfBasePlates, basePlateSize),
		paletteMode: {
			type: "auto",
			numberOfColours: defaultAutoPaletteModeNumberOfColours,
		},
		removeBackground: undefined,
		enhanceFaces: false,
		fixFaceColours: false,
		detailFilter: defaultDetailFilter,
		brightness: defaultBrightness,
		contrast: defaultContrast,
		saturation: defaultSaturation,
		pen: [],
		updatedAt: Date.now(),
	};
}

export {
	defaultContrast,
	defaultSaturation,
	defaultBrightness,
	defaultAutoPaletteModeNumberOfColours,
};
export default createDefaultPictureConfiguration;
